import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/Table";

export default function Firmware() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/firmware").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="p-5 text-muted-foreground">Loading…</div>;

  return (
    <div className="p-5 space-y-5">
      <PageHeader title="Firmware Management" subtitle={`Latest version: ${data.latest}`} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-card border border-border rounded-sm p-4">
          <div className="label-caps mb-3">Version Distribution</div>
          <div className="space-y-3">
            {data.versions.map((v) => (
              <div key={v.version}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="font-mono">{v.version}{v.version === data.latest && <span className="ml-2 text-[#34C759] text-xs">LATEST</span>}</span>
                  <span className="text-muted-foreground">{v.count} devices</span>
                </div>
                <div className="h-2 bg-secondary rounded-sm overflow-hidden">
                  <div className="h-full bg-primary" style={{ width: `${(v.count / data.versions.reduce((a, b) => a + b.count, 0)) * 100}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-card border border-border rounded-sm p-4">
          <div className="label-caps mb-3">Staged Rollout Plan</div>
          <div className="space-y-2">
            {data.rollout.map((s, i) => (
              <div key={s.stage} className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-sm bg-primary/20 text-primary flex items-center justify-center text-xs font-bold">{i + 1}</div>
                <span className="text-sm flex-1">{s.stage}</span>
                <span className="font-mono text-sm text-muted-foreground">{s.count.toLocaleString()}</span>
              </div>
            ))}
          </div>
          <p className="text-xs text-muted-foreground mt-4">Never push firmware to all devices simultaneously — stage the rollout.</p>
        </div>
      </div>
    </div>
  );
}
